// @flow
import * as React from 'react';
import { Avatar } from '@ta/styleguide.avatar';
import { useMentionsInteractionContext } from '@ta/social.mentions-tracking';

type Props = React.ElementConfig<typeof Avatar>;

// A thin wrapper around an Avatar for a MentionsNote to get around the fact that hooks must be initialized first
const MentionsNoteAvatar = (props: Props) => {
  const { userClick } = useMentionsInteractionContext();
  const { onClick: passedThroughOnClick } = props;
  const onClick = React.useCallback(
    event => {
      if (passedThroughOnClick) {
        passedThroughOnClick(event);
      }
      if (userClick) {
        userClick(event);
      }
    },
    [passedThroughOnClick, userClick],
  );
  return <Avatar {...props} onClick={onClick} />;
};
/** The MentionsNoteAvatar component */
export default React.memo<Props>(MentionsNoteAvatar);
